import { InternalUserInfoForm } from "./InternalUserInfoForm";
import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./InternalUserInfoForm.state";

InternalUserInfoForm.reducer = reducer;
InternalUserInfoForm.mapStateToProps = mapStateToProps;
InternalUserInfoForm.mapDispatchToProps = mapDispatchToProps;

export default InternalUserInfoForm;
